/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

const HR = ({ className = "", isVertical = false, hasMargin = true }) => {
  return (
    <div
      className={cn("h-[1.5px] bg-secondary w-full", className, {
        "rotate-90": isVertical,
        "!mt-s40 mb-s40": hasMargin,
      })}
      test-id="cKUnkyZx"
    />
  );
};

export default HR;
